import { motion } from "framer-motion";
import { staggerContainer, staggerItem, springPresets } from "@/lib/motion";
import { FUN_FACTS } from "@/lib/index";

export function FunFacts() {
  return (
    <section id="ilginc-bilgiler" className="py-12 px-4 bg-background">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-black text-primary mb-2" style={{ fontFamily: "'Merriweather', serif" }}>
            🌟 Biliyor muydun?
          </h2>
          <p className="text-muted-foreground">23 Nisan hakkında şaşırtıcı gerçekler!</p>
          <div className="w-24 h-1 bg-primary mx-auto mt-3 rounded-full" />
        </div>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          {FUN_FACTS.map((fact) => (
            <motion.div
              key={fact.id}
              variants={staggerItem}
              whileHover={{ y: -4, scale: 1.02 }}
              transition={springPresets.snappy}
              className="bg-card border-2 border-border rounded-xl p-6 cursor-default"
              style={{ boxShadow: "0 8px 24px -6px oklch(0.48 0.24 12 / 0.10)" }}
            >
              <div className="text-4xl mb-3">{fact.emoji}</div>
              <h3 className="text-lg font-bold text-foreground mb-2">{fact.title}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed">{fact.content}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
